'use client';

import { Box, Typography, Stack } from '@mui/material';
import { Link } from '@/i18n/routing';
import { useTranslations } from 'next-intl';

const SPACIANET_2021_INDEX = 4; // index for "SpaciaNet Japan Inc. established in Osaka"

const HistorySection = () => {
    const t = useTranslations('AboutPage.history_section');
    const items = t.raw('items') as Array<{ year: string; title: string; desc: string }>;

    return (
        <Box sx={{ py: 6 }}>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: '#132c4b', textAlign: 'center', mb: 8 }}>
                {t('title')}
            </Typography>

            <Box sx={{ position: 'relative' }}>
                {/* Vertical Line */}
                <Box sx={{
                    position: 'absolute',
                    left: { xs: '20px', md: '120px' },
                    top: 0,
                    bottom: 0,
                    width: '1px',
                    backgroundColor: '#e2e8f0',
                    zIndex: 0
                }} />

                <Stack spacing={6}>
                    {items.map((item, index) => (
                        <Box key={index} sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, position: 'relative', zIndex: 1 }}>
                            {/* Year - Left Side */}
                            <Box sx={{
                                width: { xs: 'auto', md: '120px' },
                                flexShrink: 0,
                                textAlign: { xs: 'left', md: 'right' },
                                pr: { md: 2 },
                                pl: { xs: '60px', md: 0 },
                                mb: { xs: 1, md: 0 }
                            }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#F15859' }}>
                                    {item.year}
                                </Typography>
                            </Box>

                            {/* Dot - Center */}
                            <Box sx={{
                                position: 'absolute',
                                left: { xs: '14px', md: '114px' },
                                top: '8px',
                                width: '13px',
                                height: '13px',
                                borderRadius: '50%',
                                backgroundColor: '#F15859',
                                border: '3px solid white',
                                boxShadow: '0 0 0 1px #F15859'
                            }} />

                            {/* Content - Right Side */}
                            <Box sx={{ flexGrow: 1, pl: { xs: '50px', md: 4 } }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', mb: 0.5 }}>
                                    {index === SPACIANET_2021_INDEX ? (
                                        <>
                                            {item.title.split('SpaciaNet Japan Inc.')[0]}
                                            <Link href="https://www.spacianet.co.jp" target="_blank" style={{ color: '#F15859', textDecoration: 'none', margin: '0 4px', textDecorationLine: 'underline' }}>
                                                SpaciaNet Japan Inc.
                                            </Link>
                                            {item.title.split('SpaciaNet Japan Inc.')[1]}
                                        </>
                                    ) : item.title}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b' }}>
                                    {item.desc}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Stack>
            </Box>
        </Box>
    );
};

export default HistorySection;
